module.exports = __webpack_public_path__ + "static/media/modelo-fotos.4d069ea7.png";